module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('b-button', {
    attrs: {
      "to": {
        name: 'vote-list',
        params: {
          oversea: !!JSON.parse(_vm.$route.query.oversea)
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.funcType))]), _vm._v(" 实例" + _vm._s(!!JSON.parse(_vm.$route.query.oversea) ? _vm.overseaTag : '') + "\n    ")], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "实例标题",
      "label-for": "app_name",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "app_name",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.app_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "app_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "data.app_name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "登录方式（可多选，不选任意一项视为无需登录，勾选外部登录后由接入方提供登录签名）",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "radio-group-2",
      "name": "radio-sub-component"
    },
    model: {
      value: (_vm.data.extra_login),
      callback: function($$v) {
        _vm.$set(_vm.data, "extra_login", $$v)
      },
      expression: "data.extra_login"
    }
  }, [_vm._l((_vm.extraLoginOptions), function(item, index) {
    return [_c('b-form-radio', {
      key: 'extraLogin' + index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])]
  })], 2), _vm._v(" "), _c('b-form-checkbox-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.data.extra_login),
      expression: "!data.extra_login"
    }],
    attrs: {
      "options": _vm.login_way_options,
      "name": "flavour-1a"
    },
    model: {
      value: (_vm.login_way_selected),
      callback: function($$v) {
        _vm.login_way_selected = $$v
      },
      expression: "login_way_selected"
    }
  }), _vm._v(" "), _c('b-container', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "fluid": ""
    }
  }, _vm._l((_vm.login_conf_options), function(item, key, idx) {
    return (item.conf.length > 0) ? _c('b-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.login_way_selected.indexOf(item.login_typ) !== -1),
        expression: "login_way_selected.indexOf(item.login_typ) !== -1"
      }],
      key: key,
      staticClass: "login_way_conf",
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "sm": "1"
      }
    }, [_c('h5', [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item.text) + "配置")])], 1)]), _vm._v(" "), _vm._l((item.conf), function(conf_item, conf_idx) {
      return _c('b-col', {
        key: conf_idx,
        attrs: {
          "sm": conf_item.sm
        }
      }, [_c('b-input', {
        attrs: {
          "type": "text",
          "placeholder": conf_item.text,
          "required": _vm.login_way_selected.indexOf(item.login_typ) !== -1
        },
        model: {
          value: (_vm.login_conf[item.conf_name][conf_item.conf_key]),
          callback: function($$v) {
            _vm.$set(_vm.login_conf[item.conf_name], conf_item.conf_key, $$v)
          },
          expression: "login_conf[item.conf_name][conf_item.conf_key]"
        }
      })], 1)
    })], 2) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "数据表配置",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-container', {
    staticClass: "bv-example-row",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', _vm._l((_vm.default_table_config), function(cfg_item, idx) {
    return _c('b-col', {
      key: idx
    }, [_c('h5', [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(cfg_item.text))]), _vm._v(" "), (!cfg_item.field && !_vm.update) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "link"
      },
      on: {
        "click": function($event) {
          return _vm.addTableFiled()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })]) : _vm._e()], 1)])
  }), 1), _vm._v(" "), _vm._l((_vm.data.table_config.fields), function(table_item, item_idx) {
    return _c('b-row', {
      key: item_idx,
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, _vm._l((JSON.parse(JSON.stringify(_vm.default_table_config))), function(field_item, field_idx) {
      return _c('b-col', {
        key: field_idx
      }, [(field_item.tag === 'input') ? _c('b-form-input', {
        attrs: {
          "placeholder": field_item.default,
          "disabled": _vm.update,
          "required": field_item.required
        },
        model: {
          value: (_vm.data.table_config.fields[item_idx][field_item.field]),
          callback: function($$v) {
            _vm.$set(_vm.data.table_config.fields[item_idx], field_item.field, $$v)
          },
          expression: "data.table_config.fields[item_idx][field_item.field]"
        }
      }) : (field_item.tag === 'radio') ? _c('b-form-radio-group', {
        attrs: {
          "options": JSON.parse(JSON.stringify(_vm.table_radio_options)),
          "disabled": _vm.update,
          "required": field_item.required,
          "plain": ""
        },
        model: {
          value: (_vm.data.table_config.fields[item_idx][field_item.field]),
          callback: function($$v) {
            _vm.$set(_vm.data.table_config.fields[item_idx], field_item.field, $$v)
          },
          expression: "data.table_config.fields[item_idx][field_item.field]"
        }
      }) : (field_item.tag === 'select') ? _c('b-form-select', {
        attrs: {
          "options": _vm.table_select_options[field_item.field],
          "disabled": _vm.update,
          "required": field_item.required
        },
        model: {
          value: (_vm.data.table_config.fields[item_idx][field_item.field]),
          callback: function($$v) {
            _vm.$set(_vm.data.table_config.fields[item_idx], field_item.field, $$v)
          },
          expression: "data.table_config.fields[item_idx][field_item.field]"
        }
      }) : _c('b-button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.update),
          expression: "!update"
        }],
        staticClass: "text-danger",
        attrs: {
          "pill": "",
          "required": field_item.required,
          "variant": "link"
        },
        on: {
          "click": function($event) {
            return _vm.deleteTableFiled(item_idx)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash-o"
      })])], 1)
    }), 1)
  }), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "唯一索引字段",
      "label-for": "unique_key"
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "color": "#6c757d !important"
          },
          attrs: {
            "id": "tags-validation-help-unique"
          }
        }, [_vm._v("\n                    若开启拉取投票项，则必填。\n                  ")])]
      },
      proxy: true
    }])
  }, [_c('b-form-tags', {
    attrs: {
      "input-id": "unique_key",
      "placeholder": "回车确认",
      "remove-on-delete": "",
      "tag-variant": "primary",
      "input-attrs": {
        'aria-describedby': 'tags-validation-help-unique'
      },
      "tag-validator": _vm.indexValidator,
      "disabled": _vm.update,
      "invalid-tag-text": "该字段不存在"
    },
    model: {
      value: (_vm.data.table_config.unique_keys),
      callback: function($$v) {
        _vm.$set(_vm.data.table_config, "unique_keys", $$v)
      },
      expression: "data.table_config.unique_keys"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "索引字段",
      "label-for": "index_key"
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "color": "#6c757d !important"
          },
          attrs: {
            "id": "tags-validation-help-index"
          }
        }, [_vm._v("\n                    联合索引的多个字段使用英文逗号隔开。\n                  ")])]
      },
      proxy: true
    }])
  }, [_c('b-form-tags', {
    attrs: {
      "input-id": "index_key",
      "placeholder": "回车确认",
      "remove-on-delete": "",
      "tag-variant": "primary",
      "input-attrs": {
        'aria-describedby': 'tags-validation-help-index'
      },
      "tag-validator": _vm.indexValidator,
      "disabled": _vm.update,
      "invalid-tag-text": "该字段不存在"
    },
    model: {
      value: (_vm.data.table_config.index),
      callback: function($$v) {
        _vm.$set(_vm.data.table_config, "index", $$v)
      },
      expression: "data.table_config.index"
    }
  })], 1)], 1)], 1)], 2)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "投票前强制绑定",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.bind_options,
      "name": "flavour-1a"
    },
    model: {
      value: (_vm.bind_way_selected),
      callback: function($$v) {
        _vm.bind_way_selected = $$v
      },
      expression: "bind_way_selected"
    }
  }), _vm._v(" "), _c('b-container', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "fluid": ""
    }
  }, _vm._l((_vm.bind_conf_options), function(item, key, idx) {
    return (item.conf.length > 0) ? _c('b-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bind_way_selected.indexOf(item.bind_typ) !== -1),
        expression: "bind_way_selected.indexOf(item.bind_typ) !== -1"
      }],
      key: key,
      staticClass: "bind_way_conf",
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "sm": "1"
      }
    }, [_c('h5', [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item.text) + "配置")])], 1)]), _vm._v(" "), _vm._l((item.conf), function(conf_item, conf_idx) {
      return _c('b-col', {
        key: conf_idx,
        attrs: {
          "sm": conf_item.sm
        }
      }, [_c('b-input', {
        attrs: {
          "type": "text",
          "placeholder": conf_item.text,
          "required": _vm.bind_way_selected.indexOf(item.bind_typ) !== -1
        },
        model: {
          value: (_vm.bind_conf[item.conf_name][conf_item.conf_key]),
          callback: function($$v) {
            _vm.$set(_vm.bind_conf[item.conf_name], conf_item.conf_key, $$v)
          },
          expression: "bind_conf[item.conf_name][conf_item.conf_key]"
        }
      })], 1)
    })], 2) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "是否拉取投票项",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "required": "",
      "disabled": _vm.update && !_vm.data.is_pull && _vm.data.table_config.unique_keys.length === 0
    },
    on: {
      "click": function($event) {
        _vm.data.is_pull = !_vm.data.is_pull
      }
    },
    model: {
      value: (_vm.data.is_pull),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_pull", $$v)
      },
      expression: "data.is_pull"
    }
  }), _vm._v(" "), _c('b-collapse', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "pull_config_collapse"
    },
    model: {
      value: (_vm.data.is_pull),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_pull", $$v)
      },
      expression: "data.is_pull"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "拉取配置"
    }
  }, [_vm._l((_vm.table_pull_config_params), function(item, idx) {
    return [_c('b-form-group', {
      key: idx,
      attrs: {
        "label": item.text,
        "label-for": item.field,
        "description": item.description
      }
    }, [(item.tag === 'input') ? _c('b-form-input', {
      key: idx,
      attrs: {
        "placeholder": item.placeholder,
        "id": item.field,
        "type": item.type,
        "required": _vm.data.is_pull && item.required
      },
      model: {
        value: (_vm.data.pull_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.pull_config, item.field, $$v)
        },
        expression: "data.pull_config[item.field]"
      }
    }) : (item.tag === 'input_external') ? _c('b-form-input', {
      key: idx,
      attrs: {
        "placeholder": item.placeholder,
        "id": item.field,
        "type": item.type,
        "required": _vm.data.is_pull && item.required
      },
      model: {
        value: (_vm.$data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.$data, item.field, $$v)
        },
        expression: "$data[item.field]"
      }
    }) : (item.tag === 'select') ? _c('b-form-select', {
      key: idx,
      attrs: {
        "options": _vm.table_pull_config_select_options[item.field],
        "id": item.field,
        "required": _vm.data.is_pull && item.required
      },
      model: {
        value: (_vm.data.pull_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.pull_config, item.field, $$v)
        },
        expression: "data.pull_config[item.field]"
      }
    }) : (item.tag === 'select_external') ? _c('b-form-select', {
      key: idx,
      attrs: {
        "options": _vm.table_pull_config_select_options[item.field],
        "id": item.field,
        "required": _vm.data.is_pull && item.required
      },
      model: {
        value: (_vm.$data[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.$data, item.field, $$v)
        },
        expression: "$data[item.field]"
      }
    }) : (item.tag === 'judge') ? _c('b-form-checkbox', {
      key: idx,
      attrs: {
        "switch": "",
        "required": _vm.data.is_pull && item.required
      },
      on: {
        "click": function($event) {
          _vm.data.pull_config[item.field] = !_vm.data.pull_config[item.field]
        }
      },
      model: {
        value: (_vm.data.pull_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.pull_config, item.field, $$v)
        },
        expression: "data.pull_config[item.field]"
      }
    }) : (item.tag === 'dynamic') ? [_c('b-container', {
      staticClass: "bv-example-row",
      attrs: {
        "fluid": ""
      }
    }, [_c('b-row', _vm._l((_vm.table_pull_config_params_set), function(item, idx) {
      return _c('b-col', {
        key: idx
      }, [_c('h5', [_c('b-badge', {
        attrs: {
          "pill": "",
          "variant": "primary"
        }
      }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (!item.field) ? _c('b-button', {
        attrs: {
          "size": "sm",
          "variant": "link"
        },
        on: {
          "click": function($event) {
            return _vm.addParamSetFiled()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus"
      })]) : _vm._e()], 1)])
    }), 1), _vm._v(" "), _vm._l((_vm.tmp_param_set), function(param_item, item_idx) {
      return _c('b-row', {
        key: item_idx,
        staticStyle: {
          "margin-bottom": "5px"
        }
      }, _vm._l((JSON.parse(JSON.stringify(_vm.table_pull_config_params_set))), function(item, idx) {
        return _c('b-col', {
          key: idx
        }, [(item.tag === 'input') ? _c('b-form-input', {
          model: {
            value: (_vm.tmp_param_set[item_idx][item.field]),
            callback: function($$v) {
              _vm.$set(_vm.tmp_param_set[item_idx], item.field, $$v)
            },
            expression: "tmp_param_set[item_idx][item.field]"
          }
        }) : (item.tag === 'check') ? _c('b-form-checkbox', {
          attrs: {
            "switch": ""
          },
          on: {
            "click": function($event) {
              _vm.tmp_param_set[item_idx][item.field] = !_vm.tmp_param_set[item_idx][item.field]
            }
          },
          model: {
            value: (_vm.tmp_param_set[item_idx][item.field]),
            callback: function($$v) {
              _vm.$set(_vm.tmp_param_set[item_idx], item.field, $$v)
            },
            expression: "tmp_param_set[item_idx][item.field]"
          }
        }) : _c('b-button', {
          staticClass: "text-danger",
          attrs: {
            "pill": "",
            "variant": "link"
          },
          on: {
            "click": function($event) {
              return _vm.deleteParamSetFiled(item_idx)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o"
        })])], 1)
      }), 1)
    })], 2)] : (item.tag === 'show_list') ? _vm._l((_vm.sign_params_idx), function(item, idx) {
      return _c('b-button', {
        key: idx,
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "disabled": "",
          "variant": "primary"
        }
      }, [_vm._v(_vm._s(_vm.tmp_param_set[item].key))])
    }) : _vm._e()], 2)]
  })], 2)], 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "投票限制",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-card', [_vm._l((_vm.table_limit_config_params), function(item, idx) {
    return [_c('b-form-group', {
      key: idx,
      attrs: {
        "label": item.text,
        "label-for": item.field,
        "description": item.description
      }
    }, [(item.tag === 'input') ? _c('b-form-input', {
      key: idx,
      attrs: {
        "placeholder": item.placeholder,
        "id": item.field,
        "type": item.type,
        "required": item.required
      },
      model: {
        value: (_vm.data.limit_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.limit_config, item.field, $$v)
        },
        expression: "data.limit_config[item.field]"
      }
    }) : (item.tag === 'condition-input') ? _c('b-form-input', {
      key: idx,
      attrs: {
        "placeholder": item.placeholder,
        "id": item.field,
        "type": item.type,
        "required": _vm.data.limit_config.is_limit.indexOf(item.required) !== -1,
        "disabled": _vm.data.limit_config.is_limit.indexOf(item.required) === -1
      },
      model: {
        value: (_vm.data.limit_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.limit_config, item.field, $$v)
        },
        expression: "data.limit_config[item.field]"
      }
    }) : (item.tag === 'checkbox') ? _c('b-form-checkbox-group', {
      attrs: {
        "options": _vm.limit_config_options[item.field],
        "name": "flavour-1a"
      },
      model: {
        value: (_vm.data.limit_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.limit_config, item.field, $$v)
        },
        expression: "data.limit_config[item.field]"
      }
    }) : (item.tag === 'condition-radio') ? _c('b-form-radio-group', {
      attrs: {
        "name": "radio-options",
        "required": _vm.data.limit_config.is_limit.indexOf(item.required) !== -1,
        "disabled": _vm.data.limit_config.is_limit.indexOf(item.required) === -1
      },
      model: {
        value: (_vm.data.limit_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.limit_config, item.field, $$v)
        },
        expression: "data.limit_config[item.field]"
      }
    }, [_vm._l((_vm.limit_config_options[item.field]), function(option, index) {
      return [_c('b-form-radio', {
        key: index,
        attrs: {
          "value": option.value
        }
      }, [_vm._v("\n                    " + _vm._s(option.text) + "\n                    "), (item.field === 'every' && option.value.toString() === '3' && _vm.data.limit_config.every && _vm.data.limit_config.every.toString() === '3') ? _c('b-input-group', {
        staticClass: "mb-3"
      }, [_vm._v("\n                      刷新时间：\n                      "), _c('b-form-input', {
        attrs: {
          "type": "text",
          "placeholder": "HH:mm:ss"
        },
        model: {
          value: (_vm.data.limit_config.refresh_time),
          callback: function($$v) {
            _vm.$set(_vm.data.limit_config, "refresh_time", $$v)
          },
          expression: "data.limit_config.refresh_time"
        }
      }), _vm._v(" "), _c('b-input-group-append', [_c('b-form-timepicker', {
        attrs: {
          "button-only": "",
          "right": "",
          "show-seconds": "",
          "locale": "en"
        },
        model: {
          value: (_vm.data.limit_config.refresh_time),
          callback: function($$v) {
            _vm.$set(_vm.data.limit_config, "refresh_time", $$v)
          },
          expression: "data.limit_config.refresh_time"
        }
      })], 1)], 1) : _vm._e()], 1)]
    })], 2) : (item.tag === 'judge') ? _c('b-form-checkbox', {
      attrs: {
        "switch": ""
      },
      on: {
        "click": function($event) {
          _vm.data.limit_config[item.field] = !_vm.data.limit_config[item.field]
        }
      },
      model: {
        value: (_vm.data.limit_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.limit_config, item.field, $$v)
        },
        expression: "data.limit_config[item.field]"
      }
    }) : _vm._e()], 1)]
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "时间限定",
      "description": "时间限定是在指定日期时间范围内的限制"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('label', [_vm._v("起始日期")]), _vm._v(" "), _c('b-form-datepicker', {
    staticClass: "mb-2",
    attrs: {
      "id": "limit_start_date",
      "placeholder": "起始日期",
      "required": ""
    },
    model: {
      value: (_vm.limit_start_date),
      callback: function($$v) {
        _vm.limit_start_date = $$v
      },
      expression: "limit_start_date"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('label', [_vm._v("结束日期")]), _vm._v(" "), _c('b-form-datepicker', {
    staticClass: "mb-2",
    attrs: {
      "id": "limit_end_date",
      "min": _vm.limitMinEndTime,
      "placeholder": "结束日期",
      "required": ""
    },
    model: {
      value: (_vm.limit_end_date),
      callback: function($$v) {
        _vm.limit_end_date = $$v
      },
      expression: "limit_end_date"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('label', [_vm._v("开始时间")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "HH:mm:ss",
      "required": ""
    },
    model: {
      value: (_vm.limit_start_time),
      callback: function($$v) {
        _vm.limit_start_time = $$v
      },
      expression: "limit_start_time"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-form-timepicker', {
    attrs: {
      "button-only": "",
      "right": "",
      "show-seconds": "",
      "locale": "en"
    },
    model: {
      value: (_vm.limit_start_time),
      callback: function($$v) {
        _vm.limit_start_time = $$v
      },
      expression: "limit_start_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', [_c('label', [_vm._v("结束时间")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "mb-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "HH:mm:ss",
      "required": ""
    },
    model: {
      value: (_vm.limit_end_time),
      callback: function($$v) {
        _vm.limit_end_time = $$v
      },
      expression: "limit_end_time"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-form-timepicker', {
    attrs: {
      "button-only": "",
      "right": "",
      "show-seconds": "",
      "locale": "en"
    },
    model: {
      value: (_vm.limit_end_time),
      callback: function($$v) {
        _vm.limit_end_time = $$v
      },
      expression: "limit_end_time"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 2)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "易盾配置",
      "label-class": "font-weight-bold"
    }
  }, [_c('b-card', [_vm._l((_vm.yidun_config_params), function(item, idx) {
    return [_c('b-form-group', {
      key: idx,
      attrs: {
        "label": item.text,
        "label-for": item.field,
        "description": item.description
      }
    }, [_c('b-form-input', {
      key: idx,
      attrs: {
        "placeholder": item.placeholder,
        "id": item.field,
        "type": item.type,
        "required": _vm.data.is_pull && item.required
      },
      model: {
        value: (_vm.data.yidun_config[item.field]),
        callback: function($$v) {
          _vm.$set(_vm.data.yidun_config, item.field, $$v)
        },
        expression: "data.yidun_config[item.field]"
      }
    })], 1)]
  })], 2)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "实例开始时间",
      "label-for": "ins_start_time"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "ins_start_time",
      "type": "text",
      "placeholder": "%Y-%m-%d %H:%M:%s",
      "required": ""
    },
    model: {
      value: (_vm.data.ins_start_time),
      callback: function($$v) {
        _vm.$set(_vm.data, "ins_start_time", $$v)
      },
      expression: "data.ins_start_time"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "实例结束时间",
      "label-for": "ins_end_time"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "ins_end_time",
      "type": "text",
      "placeholder": "%Y-%m-%d %H:%M:%s",
      "required": ""
    },
    model: {
      value: (_vm.data.ins_end_time),
      callback: function($$v) {
        _vm.$set(_vm.data, "ins_end_time", $$v)
      },
      expression: "data.ins_end_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" 复位")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5e2af729!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vote/VoteForm.vue
// module id = zTTy
// module chunks = 4